import { render, staticRenderFns } from "./ModalCadastraDisciplinaObjetivo.vue?vue&type=template&id=bb7891bc"
import script from "./ModalCadastraDisciplinaObjetivo.vue?vue&type=script&lang=js"
export * from "./ModalCadastraDisciplinaObjetivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports